module.exports = __webpack_public_path__ + "static/img/org.ed540a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/org.jpg
// module id = cu6A
// module chunks = 5 6